import axios from 'axios';
import jwtDecode from 'jwt-decode';
import { retryRefreshToken } from './refresh.js';
import '@dtvgo/utils';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const _AxiosTokenManager = class _AxiosTokenManager {
  constructor(authInstance, tokens, getRegion) {
    __publicField(this, "authInstance");
    __publicField(this, "tokens");
    __publicField(this, "getRegion");
    __publicField(this, "handleResponseError", async (error) => {
      const { config, response } = error;
      if ([
        "/continuewatching",
        "/playback/stop",
        "/playback/play",
        "/playback/pause",
        "/playback/streaming"
      ].some((endpoint) => config?.url?.includes(endpoint))) {
        throw error;
      }
      if (response?.status === 401 && config) {
        if (!_AxiosTokenManager.isRefreshing) {
          _AxiosTokenManager.isRefreshing = true;
          _AxiosTokenManager.refreshPromise = this.refreshTokens(error);
        }
        try {
          const newTokens = await _AxiosTokenManager.refreshPromise;
          _AxiosTokenManager.isRefreshing = false;
          _AxiosTokenManager.refreshPromise = void 0;
          if (!newTokens) {
            throw error;
          }
          const newConfig = { ...config };
          if (newConfig.headers.ssoToken) {
            newConfig.headers.ssoToken = newTokens.id_token;
          }
          if (newConfig.headers.Authorization?.startsWith("Bearer ")) {
            newConfig.headers.Authorization = `Bearer ${newTokens.id_token}`;
          } else if (newConfig.headers.Authorization) {
            newConfig.headers.Authorization = newTokens.id_token;
          }
          return await axios(newConfig);
        } catch {
          _AxiosTokenManager.isRefreshing = false;
          _AxiosTokenManager.refreshPromise = void 0;
        }
      }
      throw error;
    });
    __publicField(this, "refreshTokens", async (requestError) => {
      const currentTokens = await this.tokens.get();
      const decodedToken = jwtDecode(currentTokens.id_token);
      return retryRefreshToken(
        this.authInstance,
        currentTokens.refresh_token,
        decodedToken.businessUnit,
        decodedToken.msoProvider,
        this.getRegion,
        this.tokens,
        requestError
      );
    });
    this.authInstance = authInstance;
    this.tokens = tokens;
    this.getRegion = getRegion;
  }
};
__publicField(_AxiosTokenManager, "isRefreshing", false);
__publicField(_AxiosTokenManager, "refreshPromise");
let AxiosTokenManager = _AxiosTokenManager;
const createAxiosWithAuth = (authInstance, tokens, getRegion) => {
  const tokenManager = new AxiosTokenManager(authInstance, tokens, getRegion);
  return tokenManager.handleResponseError;
};

export { AxiosTokenManager, createAxiosWithAuth };
//# sourceMappingURL=interceptor.js.map
